"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.threeClone = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
var utils_1 = require("./utils");
/**
 * Cloning utility function
 */
function threeClone(obj, options) {
    var _a, _b, _c;
    if (options === void 0) { options = {}; }
    var cloneSkeleton = (_a = options.cloneSkeleton) !== null && _a !== void 0 ? _a : options.cloneAll;
    var cloneMaterial = (_b = options.cloneMaterial) !== null && _b !== void 0 ? _b : options.cloneAll;
    var cloneGeometry = (_c = options.cloneGeometry) !== null && _c !== void 0 ? _c : options.cloneAll;
    var objClone = cloneSkeleton
        ? realms_three_1.default.STDLIB.SkeletonUtils.clone(obj)
        : obj.clone();
    // Clone descendents
    for (var _i = 0, _d = (0, utils_1.arrayFromThreeObject)(objClone); _i < _d.length; _i++) {
        var obj_1 = _d[_i];
        if (obj_1 instanceof realms_three_1.default.Mesh) {
            if (typeof obj_1.material.clone === "function" && cloneMaterial) {
                obj_1.material = obj_1.material.clone();
            }
            if (typeof obj_1.geometry.clone === "function" && cloneGeometry) {
                obj_1.geometry = obj_1.geometry.clone();
            }
        }
    }
    return objClone;
}
exports.threeClone = threeClone;
